import log from '~/utils/log';

export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig();
    const router = useRouter();
    let isMatomoInitialized = false;
    let matomoInitializationPromise: Promise<void> | null = null;
    let hasMatomoConsent = false;
    const matomoConsent = useUsercentricsConsentItem('matomo');

    const pushMatomo = (action: unknown[]) => {
        window._paq?.push(action);
    };

    const trackCurrentView = () => {
        pushMatomo(['setCustomUrl', window.location.href]);
        pushMatomo(['trackPageView']);
    };

    const initializeMatomo = async () => {
        if (isMatomoInitialized || matomoInitializationPromise) return matomoInitializationPromise;

        matomoInitializationPromise = import('vue-matomo')
            .then(({ default: VueMatomo }) => {
                if (matomoConsent.value !== true) return;

                isMatomoInitialized = true;

                nuxtApp.vueApp.use(VueMatomo, {
                    host: config.public.matomoUrl,
                    siteId: config.public.matomoID,
                    domains: config.public.matomoDomains,
                    router,
                    enableLinkTracking: true,
                    requireConsent: true,
                    trackInitialView: true,
                    disableCookies: true,
                    requireCookieConsent: false,
                    enableHeartBeatTimer: true,
                    heartBeatTimerInterval: 5,
                    preInitActions: [['setConsentGiven']]
                });
            })
            .finally(() => {
                matomoInitializationPromise = null;
            });

        return matomoInitializationPromise;
    };

    const applyConsent = () => {
        const hasConsent = matomoConsent.value === true;

        if (hasConsent) {
            if (isMatomoInitialized) {
                pushMatomo(['setConsentGiven']);
                if (!hasMatomoConsent) trackCurrentView();
            } else {
                void initializeMatomo();
            }
        } else if (isMatomoInitialized && hasMatomoConsent) {
            pushMatomo(['forgetConsentGiven']);
        }

        hasMatomoConsent = hasConsent;
    };

    refreshUsercentricsConsentCache()
        .then(applyConsent)
        .catch((error) => {
            log.warn('Failed to refresh Usercentrics consent state', error);
        });
    onConsentUpdated(applyConsent);
});
